"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import { DropLocation } from "@/components/waves/drops/Drop";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import WaveDropActions from "@/components/waves/drops/WaveDropActions";
import MemeWinnerHeader from "./MemeWinnerHeader";
import MemeWinnerDescription from "./MemeWinnerDescription";
import MemeWinnerArtistInfo from "./MemeWinnerArtistInfo";
import MemeDropTraits from "./MemeDropTraits";
import DropMobileMenuHandler from "@/components/waves/drops/DropMobileMenuHandler";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { useDropContext } from "@/components/waves/drops/DropContext";
interface MemeWinnerDropProps {
  readonly drop: ExtendedDrop;
  readonly showReplyAndQuote: boolean;
  readonly onReply: (param: DropInteractionParams) => void;
}
export default function MemeWinnerDrop(t0) {
  const $ = _c(44);
  const {
    drop,
    showReplyAndQuote,
    onReply
  } = t0;
  const isMobile = useIsMobileDevice();
  const {
    location
  } = useDropContext();
  let t1;
  if ($[0] !== drop.metadata) {
    t1 = drop.metadata?.find(_temp)?.data_value ?? "Artwork Title";
    $[0] = drop.metadata;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const title = t1;
  let t2;
  if ($[2] !== drop.metadata) {
    t2 = drop.metadata?.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
    $[2] = drop.metadata;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const description = t2;
  let t3;
  if ($[4] !== drop.parts) {
    t3 = drop.parts.at(0)?.media?.at(0);
    $[4] = drop.parts;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const artworkMedia = t3;
  let t4;
  if ($[6] !== drop || $[7] !== onReply) {
    t4 = () => {
      onReply({
        drop,
        partId: drop.parts[0]?.part_id
      });
    };
    $[6] = drop;
    $[7] = onReply;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleOnReply = t4;
  const t5 = `tw-w-full ${location === DropLocation.WAVE ? "tw-px-4 tw-py-1" : ""} tw-group tw-relative`;
  const t6 = `tw-overflow-hidden tw-rounded-xl tw-border tw-border-l tw-border-solid tw-border-transparent tw-transition-all tw-duration-200 tw-ease-out ${location === DropLocation.WAVE ? "tw-bg-iron-900/80" : "tw-bg-iron-950"} ${"tw-shadow-[inset_1px_0_0_rgba(251,191,36,0.5),inset_0_1px_0_rgba(251,191,36,0.2),inset_-1px_0_0_rgba(251,191,36,0.2),inset_0_-1px_0_rgba(251,191,36,0.2)]"}`;
  let t7;
  if ($[9] !== drop) {
    t7 = <div className="tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4 tw-pb-3"><MemeWinnerArtistInfo drop={drop} /></div>;
    $[9] = drop;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== title) {
    t8 = <MemeWinnerHeader title={title} />;
    $[11] = title;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== description) {
    t9 = <MemeWinnerDescription description={description} />;
    $[13] = description;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <div className="tw-px-4 tw-pb-4 tw-pt-4"><div className="tw-space-y-1">{t8}{t9}</div></div>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== artworkMedia) {
    t11 = artworkMedia && <div className="tw-mx-0.5 tw-flex tw-h-96 tw-justify-center tw-bg-iron-950"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
    $[18] = artworkMedia;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== drop) {
    t12 = <div className="tw-mt-4 tw-hidden tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4 lg:tw-block"><MemeDropTraits drop={drop} /></div>;
    $[20] = drop;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t7) {
    t13 = <>{t7}{t10}{t11}{t12}</>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t7;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== drop || $[28] !== handleOnReply || $[29] !== showReplyAndQuote || $[30] !== t13) {
    t14 = <DropMobileMenuHandler drop={drop} showReplyAndQuote={showReplyAndQuote} onReply={handleOnReply}>{t13}</DropMobileMenuHandler>;
    $[27] = drop;
    $[28] = handleOnReply;
    $[29] = showReplyAndQuote;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== drop || $[33] !== handleOnReply || $[34] !== isMobile || $[35] !== showReplyAndQuote) {
    t15 = !isMobile && showReplyAndQuote && <div className="tw-absolute tw-right-4 tw-top-2"><WaveDropActions drop={drop} activePartIndex={0} onReply={handleOnReply} /></div>;
    $[32] = drop;
    $[33] = handleOnReply;
    $[34] = isMobile;
    $[35] = showReplyAndQuote;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t14 || $[38] !== t15 || $[39] !== t6) {
    t16 = <div className={t6}>{t14}{t15}</div>;
    $[37] = t14;
    $[38] = t15;
    $[39] = t6;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t16 || $[42] !== t5) {
    t17 = <div className="tw-mb-3 tw-w-full"><div className={t5}>{t16}</div></div>;
    $[41] = t16;
    $[42] = t5;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  return t17;
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp(m) {
  return m.data_key === "title";
}